<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
})

const { collectionId, id, src, alt, sizes } = defineProps<{ src?: string | File, collectionId?: string, id?: string, alt?: string, sizes?: string }>()
const url = ref()
const loaded = ref(false)
onMounted(async () => {
  if (src instanceof File) {
    const d = await readUploadedFileAsImage(src)
    url.value = d.src
  }
  loaded.value = true
})
</script>

<template>
  <img
    v-if="url && loaded"
    :src="url"
    v-bind="$attrs"
  >
  <template v-else-if="loaded && collectionId && id && src && src.match(/\.(jpg|jpeg|png|gif)$/i)">
    <NuxtPicture
      :src="getImagePath({ collectionId, id, src })"
      :alt="alt"
      :sizes="sizes"
      :img-attrs="$attrs"
    />
  </template>
  <img
    v-else-if="loaded && collectionId && id && src"
    :alt="alt"
    :src="getImagePath({ collectionId, id, src, direct: true })"
    v-bind="$attrs"
  >
</template>
